import React from 'react';

import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {
  getAddDataFrameAnalysisViewItem,
  getEnabledDatasetCreationMethods,
  trackSelectedDataFrameCreationMethodEvent,
} from 'analysis-tool/data-frame-creation/DataFrameCreationUtils';
import isArchived from 'archive/isArchived';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import UIPlaceholder from 'ui-library/UIPlaceholder';

import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EmptyAnalysisView({
  analysis,
  onOpenStepInitializationView,
}: MainViewComponentProps<AnalysisMainViewItemType.EMPTY_ANALYSIS>): JSX.Element {
  const dataFrameCreationMethods = getEnabledDatasetCreationMethods();

  return (
    <UIPlaceholder
      infoSection={
        analysis.permissions.writable
          ? 'Get started by adding a table to this analysis.'
          : "This analysis doesn't have anything in it."
      }
      actionContent={
        analysis.permissions.writable || analysis.permissions.unarchivable ? (
          <Tooltip
            title={
              dataFrameCreationMethods.length === 0
                ? 'Feature disabled - Please contact your Benchling representative for more information'
                : isArchived(analysis)
                  ? ARCHIVED_ANALYSIS_TOOLTIP_TEXT
                  : null
            }
            disabled={dataFrameCreationMethods.length > 0 && !isArchived(analysis)}
          >
            <Button
              buttonStyle={ButtonStyle.SECONDARY}
              size={ButtonSize.MEDIUM}
              text="Add analysis table"
              icon="plus-large"
              disabled={dataFrameCreationMethods.length === 0 || isArchived(analysis)}
              onClick={() => {
                onOpenStepInitializationView(getAddDataFrameAnalysisViewItem());
                if (dataFrameCreationMethods.length === 1) {
                  trackSelectedDataFrameCreationMethodEvent(
                    ActionOrigin.ANALYSIS_TOOL_EMPTY_ANALYSIS_PAGE,
                    analysis.id,
                    dataFrameCreationMethods.length,
                    dataFrameCreationMethods[0]
                  );
                }
              }}
            />
          </Tooltip>
        ) : undefined
      }
    />
  );
}
